(function() {
  'use strict';

  // Only run on screens larger than 1024px
  function shouldRunScript() {
    return window.innerWidth > 1024;
  }

  const styles = `
    <style id="dropdown-filter-styles">
      /* Only apply dropdown styles on larger screens */
      @media (min-width: 1025px) {
        /* Hide only the ORIGINAL checkbox filters, not the ones inside dropdowns */
        .t4s-facet:not(.is--dropdown-converted) .t4s-filter__values.is--style-checkbox {
          opacity: 0;
          visibility: hidden;
          transition: none;
        }
        
        .t4s-facet.is--dropdown-converted > .t4s-facet-content .t4s-filter__values.is--style-checkbox {
          display: none !important;
        }

        .t4s-dropdown-filter {
          position: relative;
          margin-bottom: 9px;
          opacity: 0;
          animation: fadeInDropdown 0.3s ease forwards;
          z-index: 1;
        }

        /* Increase z-index when dropdown is open */
        .t4s-dropdown-filter.is--open {
          z-index: 9999;
        }

        @keyframes fadeInDropdown {
          to {
            opacity: 1;
          }
        }

        .t4s-dropdown-header {
          padding: 13.5px 24px;
          background: transparent;
          border: 1px solid #A9A9A9;
          border-radius: 0;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          user-select: none;
          transition: all 0.2s ease;
          position: relative;
          z-index: 1;
        }

        .t4s-dropdown-header:hover {
          border-color: #999;
          
        }

        .t4s-dropdown-title {
          font-weight: 400;
          font-size: 20px;
          color: #323232;
          font-family: 'Open Sans';
          display: flex;
          line-height: 1em;
          align-items: center;
          gap: 10px;
        }

        .t4s-dropdown-arrow {
          transition: transform 0.3s ease;
          display: inline-block;
          font-size: 12px;
          color: #666;
        }

        .t4s-dropdown-filter.is--open .t4s-dropdown-arrow {
          transform: rotate(180deg);
        }

        .t4s-dropdown-options {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          max-height: 0;
          overflow: hidden;
          opacity: 0;
          transition: all 0.3s ease;
          z-index: 9999;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }

        .t4s-dropdown-filter.is--open .t4s-dropdown-options {
          max-height: 350px;
          overflow-y: auto;
          opacity: 1;
        }

        /* Make sure items inside dropdown are visible */
        .t4s-dropdown-options .t4s-filter__values.is--style-checkbox {
          opacity: 1 !important;
          visibility: visible !important;
        }

        .t4s-dropdown-options::-webkit-scrollbar {
          width: 8px;
        }

        .t4s-dropdown-options::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        .t4s-dropdown-options::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }

        .t4s-dropdown-options::-webkit-scrollbar-thumb:hover {
          background: #555;
        }

        .t4s-dropdown-options ul {
          list-style: none;
          margin: 0;
          padding: 8px 0;
        }

        .t4s-dropdown-options li {
          padding: 0;
          margin: 0;
        }
        

        .t4s-dropdown-options li a {
          display: flex;
          align-items: center;
          padding: 10px 15px;
          text-decoration: none;
          color: #333;
          transition: background-color 0.2s ease;
          font-size: 16px;
        }


        .t4s-dropdown-options li a:hover {
          background-color: #b084635c;
        }

        .t4s-dropdown-options li.is--selected a {
          background-color: #b084635c;
          font-weight: 500;
          color: #b08463;
        }

        .t4s-dropdown-options li.is--disabled a {
          opacity: 0.5;
          cursor: not-allowed;
          pointer-events: none;
        }

        .t4s-checkbox-wrapper {
          width: 18px;
          height: 18px;
          border: 2px solid #ddd;
          border-radius: 3px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: #fff;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        }

        .t4s-dropdown-options li.is--selected .t4s-checkbox-wrapper {
          background: #b08463;
          border-color: #b08463;
        }

        .t4s-checkbox-wrapper svg {
          opacity: 0;
          transition: opacity 0.2s ease;
          width: 14px;
          height: 14px;
        }

        .t4s-dropdown-options li.is--selected .t4s-checkbox-wrapper svg {
          opacity: 1;
        }

        .t4s-checkbox-wrapper svg path {
          fill: #fff;
        }

        .t4s-selected-count {
          background: #b08463;
          color: #fff;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 600;
          min-width: 24px;
          text-align: center;
        }

        .t4s-facet.is--dropdown-converted > .t4s-facet-title {
          display: none !important;
        }

        .t4s-facet.is--dropdown-converted > .t4s-facet-content {
          display: none !important;
        }
      }

      /* On mobile, ensure original filters are visible */
      @media (max-width: 1024px) {
        .t4s-filter__values.is--style-checkbox {
          opacity: 1 !important;
          visibility: visible !important;
        }
        
        .t4s-dropdown-filter {
          display: none !important;
        }
      }
    </style>
  `;

  if (!document.getElementById('dropdown-filter-styles')) {
    document.head.insertAdjacentHTML('beforeend', styles);
  }

  const convertedFacets = new WeakSet();
  let isInitialized = false;

  function convertCheckboxToDropdown(facetElement) {
    if (!shouldRunScript()) return false;

    if (convertedFacets.has(facetElement) || facetElement.classList.contains('is--dropdown-converted')) {
      convertedFacets.add(facetElement);
      return false;
    }

    const titleElement = facetElement.querySelector('.t4s-facet-title');
    const contentElement = facetElement.querySelector('.t4s-facet-content');
    const filterValues = facetElement.querySelector('.t4s-filter__values.is--style-checkbox');

    if (!titleElement || !contentElement || !filterValues) {
      return false;
    }

    if (facetElement.querySelector('.t4s-dropdown-filter')) {
      convertedFacets.add(facetElement);
      facetElement.classList.add('is--dropdown-converted');
      return false;
    }

    const filterTitle = titleElement.textContent.trim();
    const selectedItems = filterValues.querySelectorAll('li.is--selected');
    const selectedCount = selectedItems.length;

    const dropdownWrapper = document.createElement('div');
    dropdownWrapper.className = 't4s-dropdown-filter';
    dropdownWrapper.setAttribute('data-dropdown-filter', '');
    dropdownWrapper.setAttribute('data-filter-title', filterTitle);

    const dropdownHeader = document.createElement('div');
    dropdownHeader.className = 't4s-dropdown-header';
    dropdownHeader.setAttribute('data-dropdown-toggle', '');
    
    const headerTitle = document.createElement('span');
    headerTitle.className = 't4s-dropdown-title';
    headerTitle.textContent = filterTitle;

    if (selectedCount > 0) {
      const countBadge = document.createElement('span');
      countBadge.className = 't4s-selected-count';
      countBadge.textContent = selectedCount;
      headerTitle.appendChild(countBadge);
    }

    const arrow = document.createElement('span');
    arrow.className = 't4s-dropdown-arrow';
    arrow.innerHTML = ` <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                              stroke="#717171"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"/>
                      </svg>  `;

    dropdownHeader.appendChild(headerTitle);
    dropdownHeader.appendChild(arrow);

    const dropdownOptions = document.createElement('div');
    dropdownOptions.className = 't4s-dropdown-options';
    dropdownOptions.setAttribute('data-dropdown-content', '');

    const clonedFilterValues = filterValues.cloneNode(true);
    dropdownOptions.appendChild(clonedFilterValues);

    dropdownWrapper.appendChild(dropdownHeader);
    dropdownWrapper.appendChild(dropdownOptions);

    contentElement.parentNode.insertBefore(dropdownWrapper, contentElement);
    
    facetElement.classList.add('is--dropdown-converted');
    convertedFacets.add(facetElement);

    addDropdownEventListeners(dropdownWrapper);
    attachFilterClickHandlers(dropdownWrapper);
    
    return true;
  }

  function attachFilterClickHandlers(dropdown) {
    const links = dropdown.querySelectorAll('.t4s-dropdown-options li a');
    
    links.forEach(function(link) {
      const newLink = link.cloneNode(true);
      link.parentNode.replaceChild(newLink, link);
      
      newLink.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const facet = dropdown.closest('.t4s-facet');
        const originalContent = facet.querySelector('.t4s-facet-content');
        
        if (originalContent) {
          const linkText = newLink.textContent.trim();
          const originalLinks = originalContent.querySelectorAll('a');
          
          let originalLink = null;
          originalLinks.forEach(function(ol) {
            if (ol.textContent.trim() === linkText) {
              originalLink = ol;
            }
          });
          
          if (originalLink) {
            originalLink.click();
            
            const listItem = newLink.closest('li');
            if (listItem) {
              listItem.classList.toggle('is--selected');
            }
            
            setTimeout(function() {
              updateSelectedCounts();
            }, 100);
          }
        }
      });
    });
  }

  function addDropdownEventListeners(dropdown) {
    const toggle = dropdown.querySelector('[data-dropdown-toggle]');
    const content = dropdown.querySelector('[data-dropdown-content]');

    if (!toggle) return;

    const newToggle = toggle.cloneNode(true);
    toggle.parentNode.replaceChild(newToggle, toggle);

    newToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const allDropdowns = document.querySelectorAll('[data-dropdown-filter]');
      allDropdowns.forEach(function(otherDropdown) {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('is--open');
        }
      });

      dropdown.classList.toggle('is--open');
    });

    if (content) {
      content.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }

  function cleanupDuplicateDropdowns() {
    const dropdowns = document.querySelectorAll('[data-dropdown-filter]');
    const seenTitles = new Set();
    
    dropdowns.forEach(function(dropdown) {
      const title = dropdown.getAttribute('data-filter-title') || 
                    dropdown.querySelector('.t4s-dropdown-title')?.textContent.trim();
      
      if (title && seenTitles.has(title)) {
        dropdown.remove();
      } else if (title) {
        seenTitles.add(title);
      }
    });
  }

  function removeAllDropdowns() {
    const dropdowns = document.querySelectorAll('[data-dropdown-filter]');
    dropdowns.forEach(function(dropdown) {
      dropdown.remove();
    });
    
    const convertedFacets = document.querySelectorAll('.t4s-facet.is--dropdown-converted');
    convertedFacets.forEach(function(facet) {
      facet.classList.remove('is--dropdown-converted');
    });
  }

  function initializeDropdowns() {
    if (!shouldRunScript()) {
      removeAllDropdowns();
      return 0;
    }

    cleanupDuplicateDropdowns();
    
    const facets = document.querySelectorAll('.t4s-facet');
    let convertedCount = 0;
    
    facets.forEach(function(facet) {
      const checkboxList = facet.querySelector('.t4s-filter__values.is--style-checkbox');
      
      if (checkboxList) {
        const wasConverted = convertCheckboxToDropdown(facet);
        if (wasConverted) {
          convertedCount++;
        }
      }
    });
    
    cleanupDuplicateDropdowns();
    return convertedCount;
  }

  function handleOutsideClick(e) {
    if (!shouldRunScript()) return;
    
    if (!e.target.closest('[data-dropdown-filter]')) {
      const dropdowns = document.querySelectorAll('[data-dropdown-filter]');
      dropdowns.forEach(function(dropdown) {
        dropdown.classList.remove('is--open');
      });
    }
  }

  function handleEscapeKey(e) {
    if (!shouldRunScript()) return;
    
    if (e.key === 'Escape') {
      const dropdowns = document.querySelectorAll('[data-dropdown-filter]');
      dropdowns.forEach(function(dropdown) {
        dropdown.classList.remove('is--open');
      });
    }
  }

  function updateSelectedCounts() {
    if (!shouldRunScript()) return;
    
    const dropdowns = document.querySelectorAll('[data-dropdown-filter]');
    
    dropdowns.forEach(function(dropdown) {
      const header = dropdown.querySelector('.t4s-dropdown-title');
      const options = dropdown.querySelector('[data-dropdown-content]');
      
      if (!header || !options) return;
      
      const selectedItems = options.querySelectorAll('li.is--selected');
      const existingBadge = header.querySelector('.t4s-selected-count');
      
      if (selectedItems.length > 0) {
        if (existingBadge) {
          existingBadge.textContent = selectedItems.length;
        } else {
          const countBadge = document.createElement('span');
          countBadge.className = 't4s-selected-count';
          countBadge.textContent = selectedItems.length;
          header.appendChild(countBadge);
        }
      } else {
        if (existingBadge) {
          existingBadge.remove();
        }
      }
    });
  }

  function waitForFiltersAndInit() {
    if (!shouldRunScript()) return;
    
    let attempts = 0;
    const maxAttempts = 20;
    
    function tryInit() {
      attempts++;
      const facets = document.querySelectorAll('.t4s-facet');
      
      if (facets.length > 0) {
        const converted = initializeDropdowns();
        updateSelectedCounts();
        
        if (converted > 0) {
          isInitialized = true;
          return true;
        }
      }
      
      if (attempts < maxAttempts) {
        setTimeout(tryInit, 500);
      }
    }
    
    tryInit();
  }

  let initTimeout;
  function debouncedInit() {
    clearTimeout(initTimeout);
    initTimeout = setTimeout(function() {
      cleanupDuplicateDropdowns();
      initializeDropdowns();
      updateSelectedCounts();
    }, 300);
  }

  function handleResize() {
    if (shouldRunScript()) {
      if (!isInitialized) {
        waitForFiltersAndInit();
      }
    } else {
      removeAllDropdowns();
      isInitialized = false;
    }
  }

  function init() {
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleEscapeKey);

    // Listen for window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        waitForFiltersAndInit();
      });
    } else {
      waitForFiltersAndInit();
    }

    const observer = new MutationObserver(function(mutations) {
      if (!shouldRunScript()) return;
      
      let shouldReinit = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.classList && (
                  node.classList.contains('t4s-facet') || 
                  node.classList.contains('t4s-drawer') ||
                  node.id === 'FacetFiltersForm'
              )) {
                shouldReinit = true;
              }
              
              if (node.querySelector && node.querySelector('.t4s-facet')) {
                shouldReinit = true;
              }
            }
          });
        }
        
        if (mutation.type === 'attributes' && mutation.target.classList) {
          if (mutation.target.classList.contains('t4s-drawer') || 
              mutation.target.id === 't4s-filter-hidden') {
            shouldReinit = true;
          }
        }
      });
      
      if (shouldReinit) {
        debouncedInit();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  init();

})();